/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { IntlService } from 'ember-intl';
import type { InvoiceStatus } from 'walden-fast/types/invoice';
import { t } from 'walden-fast/utils/intl';

export interface InvoiceStateTagSignature {
  Args: {
    state: InvoiceStatus;
  };
}

const VARIANTS: Record<InvoiceStatus, string> = {
  pending: 'gray',
  paid: 'green',
};

const translationKeyMap: Record<InvoiceStatus, string> = {
  pending: t('components.invoiceStateTag.pending'),
  paid: t('components.invoiceStateTag.paid'),
};

export default class InvoiceStateTagComponent extends Component<InvoiceStateTagSignature> {
  @service('intl') declare intl: IntlService;

  get variant() {
    return VARIANTS[this.args.state];
  }

  get stateTranslation() {
    return this.intl.t(translationKeyMap[this.args.state]);
  }
}
